import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

const ReasonsTable = ({ declines }) => {
  if (!declines || declines.length === 0) return <p>No decline reasons available.</p>;

  const columns = [
    {
      title: 'Declined Reason',
      dataIndex: 'reason',
      key: 'reason',
      render: (text) => text || 'N/A',
    },
    {
      title: 'External Comment',
      dataIndex: 'external-comment',
      key: 'externalComment',
      render: (text) => text || 'N/A',
    },
  ];

  return (
    <Table
      dataSource={declines.map((decline, index) => ({ ...decline, key: index }))}
      columns={columns}
      pagination={false}
      bordered
      size="small"
    />
  );
};

ReasonsTable.propTypes = {
  declines: PropTypes.arrayOf(PropTypes.object),
};

export default ReasonsTable;
